export default __webpack_public_path__ + "static/media/dex-info-img.b3fe0c71.svg";